// dimensions are defined here so that they can be consistent
// when generating image src sets and skeleton card sizes
export const productImageDimensions = {
  detail: [
    { height: 644, width: 644 },
    { height: 375, width: 375 },
  ], // PDP design: https://www.figma.com/file/FMeVgqTXinZ2phbcHorWbU/Design?type=design&node-id=8065-135226&mode=design&t=ZnUXtqGMMAGGp2OD-4
  searchResult: { height: 308, width: 308 }, // PLP design: https://www.figma.com/file/FMeVgqTXinZ2phbcHorWbU/Design?type=design&node-id=8113-5209&mode=design&t=ZnUXtqGMMAGGp2OD-4
};
